import {WizardFocus} from './wizardFocus';

export interface INodeHistoryEngine {
    goBack(target?: WizardFocus): WizardFocus;
    addToHistory(node: WizardFocus);
    getHistoryList(): WizardFocus[];
    restoreHistory(history: WizardFocus[]);
}

export class HistoryNodeNavigationEngineFactory {
    public static $inject = ['$log'];
    constructor(private $log: ng.ILogService) { }

    public getInstance(): INodeHistoryEngine {
        return new HistoryNodeNavigationEngine(this.$log);
    }
}

// tslint:disable-next-line:max-classes-per-file
export class HistoryNodeNavigationEngine implements INodeHistoryEngine {
    private nodeHistory: WizardFocus[] = [];

    constructor(private $log: ng.ILogService) { }

    public getHistoryList(): WizardFocus[] {
        return this.nodeHistory.slice(0);
    }
    
    public addToHistory(node: WizardFocus) {
        if (angular.isDefined(node))
            this.nodeHistory.push(node);
    }

    public goBack(target?: WizardFocus): WizardFocus {

        // rule:  if the node was not a repeated sub-node, we just return it.
        // if it is a repeated sub-node, we have to be suspicious because it is possible that its record has been removed from the source array
        // (like if you move forward through the wizard, and then delete a location that is in your history) -- for those, we have to check whether its data is in the history first
        let focus = angular.isDefined(target) ? this.truncateHistory(target) : this.nodeHistory.pop();
        while (angular.isDefined(focus)) {
            
            // if there is no subject, then we aren't in a data-driven sub-node.  There is no need to check whether the subject data still exists
            if (angular.isUndefined(focus.subject))
                break;

            // if this is the parent node (like the location container for locations), then focus will be an array
            if (angular.isArray(focus.subject))
                break;    
            
            // if the parent has an array of records, this sub-node was repeating them.  validate that the record this focus references is still part of the set (not been deleted)
            if (angular.isArray(focus.node.parent.subjectData) && (focus.node.parent.subjectData as any[]).indexOf(focus.subject) >= 0)
                break;
            
            focus = this.nodeHistory.pop();
        }
        return focus;
    }

    public restoreHistory(history: WizardFocus[]): void {
        this.nodeHistory = history;
    }

    private truncateHistory(target: WizardFocus): WizardFocus {
        const index = this.nodeHistory.lastIndexOf(target);
        if (index < 0) {
            this.$log.error('Wizard: Attempted to navigate in history to a node that has not been visited (is not in history)', { 'target': target, 'history': this.nodeHistory });
            return undefined;
        }
        
        const result = this.nodeHistory[index];
        this.nodeHistory.splice(index);
        return result;
    }
}